import { getValidCountryData } from "./countryFlags";
import { getDisplayedTime } from "./datetime";
import { RoomStatus } from "./roomDossier";
import { RoomListSource } from "./types";
export function parseIRoomInfo(rawRoomInfo, includeExtendedInfo = false) {
    var _a;
    const getViewerCount = (rawRoomInfo, key) => {
        const viewers = rawRoomInfo.getNumber(key, false);
        return isNaN(viewers) ? -1 : viewers;
    };
    // We want to use startTimestamp to perform calculations for timeOnline on the FE
    const roomLabel = rawRoomInfo.getString("label", false);
    const startTs = rawRoomInfo.getNumberOrUndefined("start_timestamp", false);
    const countryCode = (_a = rawRoomInfo
        .getStringOrUndefined("country")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const { flagCode, flagName } = getValidCountryData(countryCode);
    return Object.assign({ room: rawRoomInfo.getString("room", false) ||
            rawRoomInfo.getString("username", false), label: roomLabel, img: rawRoomInfo.getString("img"), gender: rawRoomInfo.getString("gender"), subject: rawRoomInfo.getString("subject", false) ||
            rawRoomInfo.getString("room_subject", false), timeOnline: getDisplayedTime(roomLabel === RoomStatus.Offline, startTs === 0 ? undefined : startTs), viewers: Math.max(getViewerCount(rawRoomInfo, "viewers"), getViewerCount(rawRoomInfo, "num_users")), location: rawRoomInfo.getStringOrUndefined("location"), displayAge: rawRoomInfo.getStringWithNumbers("display_age", false) ||
            rawRoomInfo.getStringWithNumbers("age", false), isFollowing: rawRoomInfo.getBoolean("is_following", false, false), isNew: rawRoomInfo.getBoolean("is_new", false, false), isGaming: rawRoomInfo.getBoolean("is_gaming", false, false), sourceName: parseRoomListSource(rawRoomInfo.getStringOrUndefined("source_name")), sourcePosition: rawRoomInfo.getNumberOrUndefined("source_position"), sourceInfo: rawRoomInfo.getStringOrUndefined("source_info"), startTimestamp: startTs, countryCode: flagCode, countryName: flagName, privatePrice: rawRoomInfo.getNumberOrUndefined("private_price"), spyPrice: rawRoomInfo.getNumberOrUndefined("spy_show_price") }, (includeExtendedInfo && {
        extendedInfo: parseExtendedRoomInfo(rawRoomInfo),
    }));
}
function parseExtendedRoomInfo(rawRoomInfo) {
    return {
        score: rawRoomInfo.getNumberOrUndefined("score"),
        scoreRank: rawRoomInfo.getNumberOrUndefined("score_rank"),
        baseScore: rawRoomInfo.getNumberOrUndefined("base_score"),
        baseRank: rawRoomInfo.getNumberOrUndefined("base_rank"),
        satScore: rawRoomInfo.getNumberOrUndefined("sat_score"),
        satPercent: rawRoomInfo.getNumberOrUndefined("sat_percent"),
        defaultPenalty: rawRoomInfo.getNumberOrUndefined("default_penalty"),
        manualPenalty: rawRoomInfo.getNumberOrUndefined("manual_penalty"),
        numRegs: rawRoomInfo.getNumberOrUndefined("num_regs"),
        coloredRegs: rawRoomInfo.getNumberOrUndefined("colored_regs"),
        tipRate: rawRoomInfo.getNumberOrUndefined("tip_rate"),
        smallRoomScore: rawRoomInfo.getNumberOrUndefined("small_room_sort_score"),
    };
}
// eslint-disable-next-line complexity
export function parseRoomListSource(source) {
    switch (source) {
        case RoomListSource.Default:
        case RoomListSource.Recommended:
        case RoomListSource.RecommendedSearch:
        case RoomListSource.FallbackRoomlist:
        case RoomListSource.FollowedTab:
        case RoomListSource.RecommendedFollow:
        case RoomListSource.FollowedNotification:
        case RoomListSource.FollowedPageOnline:
        case RoomListSource.FollowedPageOffline:
        case RoomListSource.MoreLikeThis:
        case RoomListSource.MoreRooms:
        case RoomListSource.TagPage:
        case RoomListSource.Promoted:
        case RoomListSource.Boosted:
        case RoomListSource.NextCam:
        case RoomListSource.ScanCam:
        case RoomListSource.Discover:
        case RoomListSource.Trending:
        case RoomListSource.Small:
        case RoomListSource.PrivateShows:
        case RoomListSource.CommunityControlledShows:
        case RoomListSource.AffiliatesCamListing:
            return source;
        default:
            return RoomListSource.Unknown;
    }
}
